// Plan codes as returned in `activePackage`, mapped to the names the iOS app shows
export const PLAN_NAMES = {
  S: 'Anywhere Intercom',
  G: 'Global Access',
  LB: 'GCP - Bronze',
  L: 'GCP - Gold',
  LS: 'GCP - Silver',
  LK: 'GCP - Starter Kit',
  LT: "GCP - Travelers' Plan",
  M: 'Office Connect',
}

export const NO_PLAN = 'No Plan'

export const getPlanName = (code) => PLAN_NAMES[code] || NO_PLAN
